module.exports = __webpack_public_path__ + "static/media/m4tj0.d64a70b3.png";